function VerticalDivider() {
    return (
        <div
            className="amenities--count-amenity_divider-vertical"
        />
    )
}

export default VerticalDivider